export enum GenderCode {
  Male = 'male',
  Female = 'female',
  Unknown = 'unknown',
}
